class ReadMore {
	constructor() {
		this.isOpen = false;
		this.textElements = document.querySelector( '.js-school-presentation-text' );
		this.readMoreButton = document.querySelector( '.js-school-read-more' );
		this.charCount = 120;

		if ( ! this.readMoreButton || ! this.textElements ) {
			return;
		}

		this.storedText = this.textElements?.innerHTML;

		if ( this.checkOverflow() ) {
			this.truncateText();
		}

		this.readMoreButton.addEventListener( 'click', this.handleOnClick );
	}

	/**
	 * Shortens text by the char count with an ellipsis at the end
	 */
	truncateText = () => {
		this.textElements.innerHTML = `${ this.textElements.firstChild.innerText.slice( 0, this.charCount ) }...`;
	};

	/**
	 * Opens and closes the full text in the read more section on click
	 *
	 * @param {Event} event
	 */
	handleOnClick = event => {
		let readMoreClosedDefault = 'Läs mer';
		let readMoreOpenedDefault = 'Läs mindre';

		if ( 0 < document.querySelectorAll( 'body.single-school' ).length ) {
			readMoreClosedDefault = 'Läs hela skolans presentation';
			readMoreOpenedDefault = 'Visa mindre av skolans presentation';
		}
		if ( this.isOpen ) {
			event.target.innerText = readMoreClosedDefault;
			this.truncateText();
		} else {
			this.textElements.innerHTML = this.storedText;
			event.target.innerText = readMoreOpenedDefault;
		}

		this.isOpen = ! this.isOpen;
	};

	/**
	 * Checks if the text has multiple lines or exceeds the char limit
	 * Also hides the read more button if true (refactor into separate function if this gets bigger)
	 *
	 * @return {boolean} if the text has multiple lines or exceeds the char limit
	 */
	checkOverflow = () => {
		const hasMultipleLines = this.textElements.childElementCount > 1;

		if ( this.textElements.firstChild.innerText.length < this.charCount && ! hasMultipleLines ) {
			this.readMoreButton.hidden = true;
			return false;
		}

		return true;
	};
}

export default ReadMore;
